import { Text } from '@chakra-ui/react';
import React, { FC } from 'react';
import { formatDate } from '@app/helpers/formatDate';
import { format } from 'date-fns';
import { DATE_FORMAT } from '@app/constants/common';

type Props = {
  date: Date | null;
};

export const LockedUntilSection: FC<Props> = ({ date }) => {
  return (
    <Text fontSize="14px" lineHeight="26px" color="gray.4" textAlign="start">
      {date ? format(date, DATE_FORMAT) : '-'}
    </Text>
  );
};
